export default __webpack_public_path__ + "7fb4da2cb30cd7dd57bfb35f8a0c775e.png";